import { useQuery } from '@tanstack/react-query';

import { fetchPages } from '../services/api/pages';

export const usePages = () => {
  return useQuery({
    queryKey: ['pages'],
    queryFn: fetchPages,
    initialData: [],
  });
};
